/*
*修改登录密码
*/
const __request = require(`./__request/__request_contentType_json`)
const request = (data) => {
    let pParameter = {
        method: 'post',
        urlSuffix: '/web/common/user/updatePassword',
        data: data
    }
    return __request(pParameter)
}
export default request